import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	selectItem: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		':has(*) svg': {
			display: 'block',
		},
	},
	selectValueDisplay: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	trigger: {
		width: '100%',
		gap: 8,
	},
});
